<div *ngIf="isAffiliateBannerShown$ | async" class="banner">
  <div class="banner-content">
    <h4 class="banner-title">{{ 'Welcome to CaseActive' | translate }}</h4>
    <p class="banner-description">{{ 'We\'re thrilled to have you here. We can\'t wait to assist you on your journey to enhance your client collaboration through our trusted partnership with' | translate }} {{ affiliateName$ | async }}.
    </p>
  </div>
  <div class="banner-actions">
    <button (click)="onGetStarted()" type="button" class="primary">{{ 'Get Started' | translate }}</button>
    <button (click)="onCloseBanner()" type="button" class="primary close">{{ 'Later' | translate }}</button>
  </div>
</div>